import React, { useEffect } from 'react';
import HubspotEmbed from '../HubspotEmbed';
import { handleUTMsEvent } from '../Utilities/hubspotEmbedGetUTMs';
import { Container } from './styles/HubspotStyles.styled';

const EventsForm = () => {
  useEffect(() => {
    if (typeof window === 'undefined') return;

    window.addEventListener('hs-form-event:on-ready', handleUTMsEvent);

    return () => {
      window.removeEventListener('hs-form-event:on-ready', handleUTMsEvent);
    };
  }, []);

  return (
    <Container>
      <HubspotEmbed
        portalId="243522351"
        formId="879b1594-8b62-4daf-8f85-fd71097b78c4"
        region="na2"
      />
    </Container>
  );
};

export default EventsForm;
